export default class PersonalInfo{
  constructor(){
    this.dob = '';
    this.firstName = '';
    this.lastName = '';
    this.phone = '';
    this.email = '';
    this.age = 0;
    this.termsAndConditions = false;
  }
}
